import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

import { Logger } from "utils/logger";

const ERROR_REDIRECTS: Record<string, string> = {
  existingDomain: "/SignUp?error=existingDomain",
  invalidEmail: "/SignUp?error=invalidEmail",
  pendingInvitation: "/SignUp?error=pendingInvitation",
  previousTrial: "/SignUp?error=previousTrial",
};

const Auth0Callback: React.FC = (): JSX.Element => {
  const { error, getAccessTokenSilently, isAuthenticated, isLoading } =
    useAuth0();
  const navigate = useNavigate();

  useEffect((): void => {
    async function exchangeToken(): Promise<void> {
      if (error) {
        Logger.error("Auth0 authentication failed", {
          error: error.message,
        });
        void navigate("/SignUp?error=auth0");

        return;
      }

      if (!isAuthenticated) {
        void navigate("/");

        return;
      }

      try {
        const token = await getAccessTokenSilently();
        const response = await fetch(`${window.location.origin}/auth/auth0`, {
          body: JSON.stringify({ token }),
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          method: "POST",
        });

        if (response.ok) {
          void navigate("/home");
        } else {
          const data: { error: string } = await response.json();
          const redirect = ERROR_REDIRECTS[data.error] ?? "/";

          Logger.error("Auth0 token exchange failed", {
            error: data.error,
            status: response.status,
          });
          void navigate(redirect);
        }
      } catch {
        Logger.error("Auth0 token exchange error");
        void navigate("/");
      }
    }

    if (!isLoading) {
      void exchangeToken();
    }
  }, [error, getAccessTokenSilently, isAuthenticated, isLoading, navigate]);

  return <p>{"Completing sign in..."}</p>;
};

export { Auth0Callback };
